import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { AnimatedGTLDs } from './AnimatedGTLDs';
import { Timeline } from './Timeline';
export function EarlyWarningReport() {
  const pageTitle = '2026 New gTLD Application Round - Early Warning Report';
  const pageDescription = 'Get Data on Whether Your Desired String is Likely to Be In Contention While There is Still Time to Do Something About It';
  const pageUrl = 'https://earlywarningreport.com'; // Replace with your actual domain
  return <>
      <Helmet data-id="element-67">
        {/* Primary Meta Tags */}
        <title data-id="element-68">{pageTitle}</title>
        <meta name="title" content={pageTitle} data-id="element-69" />
        <meta name="description" content={pageDescription} data-id="element-70" />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" data-id="element-71" />
        <meta property="og:url" content={pageUrl} data-id="element-72" />
        <meta property="og:title" content="Early Warning Report" data-id="element-73" />
        <meta property="og:description" content="Get Data on Whether Your Desired String is Likely to Be In Contention While There is Still Time to Do Something About It" data-id="element-74" />
        <meta property="og:site_name" content="Early Warning Report" data-id="element-75" />
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-76" />
        <meta name="twitter:url" content={pageUrl} data-id="element-77" />
        <meta name="twitter:title" content={pageTitle} data-id="element-78" />
        <meta name="twitter:description" content={pageDescription} data-id="element-79" />
        {/* Additional Meta Tags */}
        <meta name="robots" content="index, follow" data-id="element-80" />
        <link rel="canonical" href={pageUrl} data-id="element-81" />
      </Helmet>
      <section className="w-full bg-white text-secondary-800 text-base leading-7 font-sans rounded-xl shadow-2xl overflow-hidden" data-id="element-82">
        <div className="bg-gradient-to-br from-primary-700 via-primary-600 to-primary-800 text-white py-16 px-8 relative overflow-hidden" data-id="element-83">
          <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1200&q=80')",
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }} data-id="element-84"></div>
          <AnimatedGTLDs data-id="element-85" />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-900/20 to-transparent" data-id="element-86"></div>
          <div className="relative z-10" data-id="element-87">
            <h1 className="font-display text-4xl md:text-6xl font-bold mb-6 text-center leading-tight" data-id="element-88">
              2026 New GTLD Application Round
              <span className="block mt-3 text-primary-100 text-3xl md:text-5xl" data-id="element-89">
                Early Warning Report
              </span>
            </h1>
            <p className="text-center text-xl md:text-2xl max-w-3xl mx-auto text-primary-50 font-medium" data-id="element-90">
              Find Out if Your Desired String is Available in the Next Round
              
              </p>
            <p className="text-center text-xl md:text-2xl max-w-3xl mx-auto text-primary-50 font-medium" data-id="element-91">
              Get Data on Whether Your Desired String is Likely to Be In
              Contention
            </p>
          </div>
        </div>
        <div className="px-8 py-12 max-w-6xl mx-auto" data-id="element-92">
          {/* Counter Section */}
          <div className="flex justify-center mb-12" data-id="element-93">
            <div className="bg-gradient-to-br from-primary-600 to-primary-700 rounded-2xl shadow-2xl p-8 text-center min-w-[280px] border-4 border-primary-200" data-id="element-94">
              <h3 className="text-white text-xl font-semibold mb-4 uppercase tracking-wide" data-id="element-95">
                Committed Strings
              </h3>
              <div className="text-white text-6xl font-bold font-display" data-id="element-96">
                7
              </div>
            </div>
          </div>
          <div className="space-y-12" data-id="element-97">
            <div className="backdrop-blur-sm bg-white/80 rounded-2xl p-8 shadow-lg border border-secondary-100 hover:shadow-xl transition-all duration-300" data-id="element-98">
              <h2 className="font-display text-3xl md:text-4xl font-bold text-primary-700 mb-6" data-id="element-99">
                What Does the Early Warning Report Service Do?
              </h2>
              <ul className="space-y-4" data-id="element-100">
                <li className="flex items-start" data-id="element-101">
                  <span className="text-primary-600 mr-3 text-xl flex-shrink-0" data-id="element-102">
                    •
                  </span>
                  <div className="text-secondary-700 leading-relaxed text-lg" data-id="element-103">
                    <strong className="font-bold" data-id="element-104">
                      Identifies potential contention sets at two critical
                      junctures:
                    </strong>
                    <ul className="ml-6 mt-2 space-y-2" data-id="element-105">
                      <li className="flex items-start" data-id="element-106">
                        <span className="text-primary-400 mr-2 flex-shrink-0" data-id="element-107">
                          ◦
                        </span>
                        <span data-id="element-108">Before the application window closes; and</span>
                      </li>
                      <li className="flex items-start" data-id="element-109">
                        <span className="text-primary-400 mr-2 flex-shrink-0" data-id="element-110">
                          ◦
                        </span>
                        <span data-id="element-111">
                          After the application window closes but before Reveal
                          Day
                        </span>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-112">
                  <span className="text-primary-600 mr-3 text-xl flex-shrink-0" data-id="element-113">
                    •
                  </span>
                  <div className="text-secondary-700 leading-relaxed text-lg" data-id="element-114">
                    <strong className="font-bold" data-id="element-115">
                      Gives participants the ability to:
                    </strong>
                    <ul className="ml-6 mt-2 space-y-2" data-id="element-116">
                      <li className="flex items-start" data-id="element-117">
                        <span className="text-primary-400 mr-2 flex-shrink-0" data-id="element-118">
                          ◦
                        </span>
                        <span data-id="element-119">
                          Make strategic application decisions based on more
                          data
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-120">
                        <span className="text-primary-400 mr-2 flex-shrink-0" data-id="element-121">
                          ◦
                        </span>
                        <span data-id="element-122">
                          Anonymously contact other applicants interested in the
                          same or similar strings likely to be in contention
                        </span>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-123">
                  <span className="text-primary-600 mr-3 text-xl flex-shrink-0" data-id="element-124">
                    •
                  </span>
                  <span className="text-secondary-700 leading-relaxed text-lg" data-id="element-125">
                    This information can enable applicants to avoid contention
                    and ICANN auctions by either changing strings or attempting
                    to resolve the potential contention before the ICANN
                    prohibition on private resolution begins at Reveal Day
                  </span>
                </li>
              </ul>
            </div>
            <div className="backdrop-blur-sm bg-white/80 rounded-2xl p-8 shadow-lg border border-secondary-100 hover:shadow-xl transition-all duration-300" data-id="element-126">
              <h2 className="font-display text-3xl md:text-4xl font-bold text-primary-700 mb-6" data-id="element-127">
                Why is the Early Warning Report Service Needed?
              </h2>
              <ul className="space-y-4" data-id="element-128">
                <li className="flex items-start" data-id="element-129">
                  <span className="text-primary-600 mr-3 text-xl flex-shrink-0" data-id="element-130">
                    •
                  </span>
                  <div className="text-secondary-700 leading-relaxed text-lg" data-id="element-131">
                    <strong className="font-bold" data-id="element-132">
                      The upcoming round is different - No private auctions for
                      strings in contention
                    </strong>
                    <ul className="ml-6 mt-2 space-y-2" data-id="element-133">
                      <li className="flex items-start" data-id="element-134">
                        <span className="text-primary-400 mr-2 flex-shrink-0" data-id="element-135">
                          ◦
                        </span>
                        <span data-id="element-136">
                          In the first round of new gTLD applications, if there
                          was more than one application for the same string (and
                          those deemed too similar), they were put in a
                          contention set
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-137">
                        <span className="text-primary-400 mr-2 flex-shrink-0" data-id="element-138">
                          ◦
                        </span>
                        <span data-id="element-139">
                          The applicants then had the option of resolving the
                          contention set privately, including through private
                          auctions where the losers shared the winning bid, or
                          joint ventures, or through an auction of last resort
                          operated by ICANN where ICANN kept the auction
                          proceeds
                        </span>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-140">
                  <span className="text-primary-600 mr-3 text-xl flex-shrink-0" data-id="element-141">
                    •
                  </span>
                  <div className="text-secondary-700 leading-relaxed text-lg" data-id="element-142">
                    <strong className="font-bold" data-id="element-143">How it Works Now</strong>
                    <ul className="ml-6 mt-2 space-y-2" data-id="element-144">
                      <li className="flex items-start" data-id="element-145">
                        <span className="text-primary-400 mr-2 flex-shrink-0" data-id="element-146">
                          ◦
                        </span>
                        <span data-id="element-147">
                          ICANN has prohibited all private resolution of
                          contention sets after Reveal Day (the day that ICANN
                          reveals all of the strings that have been applied for)
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-148">
                        <span className="text-primary-400 mr-2 flex-shrink-0" data-id="element-149">
                          ◦
                        </span>
                        <span data-id="element-150">
                          Once Reveal Day occurs, any applicant who is in
                          contention for their string will only have three
                          choices:
                        </span>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
              <div className="space-y-6 my-8" data-id="element-151">
                <div className="bg-white rounded-xl p-8 shadow-lg border border-secondary-200" data-id="element-152">
                  <div className="flex items-start group" data-id="element-153">
                    <span className="flex-shrink-0 flex items-center justify-center bg-gradient-to-br from-primary-600 to-primary-700 text-white rounded-full w-8 h-8 mr-5 text-sm font-bold shadow-lg group-hover:scale-110 transition-transform" data-id="element-154">
                      1
                    </span>
                    <span className="text-secondary-700 text-lg" data-id="element-155">
                      Withdraw their application and{' '}
                      <strong className="font-bold" data-id="element-156">
                        lose at least $79,450
                      </strong>{' '}
                      (35% of $227,000) plus accounting, legal and consulting
                      fees.
                    </span>
                  </div>
                </div>
                <div className="text-center font-bold text-secondary-700 text-xl py-2" data-id="element-157">
                  OR
                </div>
                <div className="bg-white rounded-xl p-8 shadow-lg border border-secondary-200" data-id="element-158">
                  <div className="flex items-start group" data-id="element-159">
                    <span className="flex-shrink-0 flex items-center justify-center bg-gradient-to-br from-primary-600 to-primary-700 text-white rounded-full w-8 h-8 mr-5 text-sm font-bold shadow-lg group-hover:scale-110 transition-transform" data-id="element-160">
                      2
                    </span>
                    <span className="text-secondary-700 text-lg" data-id="element-161">
                      Fail to win or don't bid in the ICANN Auction and{' '}
                      <strong className="font-bold" data-id="element-162">
                        lose at least $147,550
                      </strong>{' '}
                      (65% of $227,000) plus accounting, legal and consulting
                      fees.
                    </span>
                  </div>
                </div>
                <div className="text-center font-bold text-secondary-700 text-xl py-2" data-id="element-163">
                  OR
                </div>
                <div className="bg-white rounded-xl p-8 shadow-lg border border-secondary-200" data-id="element-164">
                  <div className="flex items-start group" data-id="element-165">
                    <span className="flex-shrink-0 flex items-center justify-center bg-gradient-to-br from-primary-600 to-primary-700 text-white rounded-full w-8 h-8 mr-5 text-sm font-bold shadow-lg group-hover:scale-110 transition-transform" data-id="element-166">
                      3
                    </span>
                    <span className="text-secondary-700 text-lg" data-id="element-167">
                      Win the ICANN auction and pay the highest bid amount to
                      ICANN
                    </span>
                  </div>
                </div>
              </div>
              <p className="text-secondary-700 leading-relaxed text-lg" data-id="element-168">
                This leaves every potential applicant with the same question:
                "What is the likelihood that my application will end up in
                contention?" The answer was always the same: there is no way to
                know -{' '}
                <strong className="text-primary-700 font-bold" data-id="element-169">
                  until now
                </strong>
                .
              </p>
              <div className="my-6" data-id="element-170"></div>
              <p className="text-secondary-700 leading-relaxed text-lg" data-id="element-171">
                With the Early Warning Report Service, those considering
                applying for new gTLDs in the upcoming round will have
                previously unavailable insight into the likelihood that their
                desired string will end up in contention. This gives Early
                Warning Report participants more information and options than
                other applicants and enables them to pivot strategically and
                either change to a different string or to resolve the potential
                contention with other applicants{' '}
                <strong className="text-primary-700 font-bold" data-id="element-172">
                  <em data-id="element-173">before </em>
                </strong>
                submitting an application or before Reveal Day.
              </p>
              <div className="my-6" data-id="element-174"></div>
              <p className="text-secondary-700 leading-relaxed text-lg" data-id="element-175">
                Applicants now have the choice of going in blind and risking
                their application fee and more, or doing so armed with
                additional information.
              </p>
            </div>

            <div className="bg-primary-50 border border-primary-200 rounded-lg p-6 mt-8" data-id="element-176">
              <div className="text-center" data-id="element-177">
                <h3 className="font-display text-xl font-bold text-primary-700 mb-3" data-id="element-178">
                  Ready to get started?
                </h3>
                <p className="text-secondary-700 mb-6" data-id="element-179">
                  Join the Early Warning Report Service today and gain a
                  competitive advantage.
                </p>
                <Link to="/contact" data-id="element-180">
                  <button className="bg-primary-600 hover:bg-primary-700 text-white font-bold py-3 px-8 rounded-md transition-colors shadow-sm" data-id="element-181">
                    Contact Us
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}